import { Helmet } from 'react-helmet';
import Header from '../../../components/Header/Header';
import { APP_TITLE } from '../../../utils/constants';
import { createStyles, makeStyles, Paper, Theme } from '@material-ui/core';
import { GetString } from '../../../components/StringResourceManager';
import { FeaturesNameListBox } from '../../../components/Config/Features/FeaturesNameListBox';
import { getDivisionList } from '../../../store/Assets/AssetsActions';
import { useEffect } from 'react';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
  }),
);

export default function FeaturesSubMenu() {
  const classes = useStyles();

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getDivisionList(dispatch);
    }
    return () => {};
  }, [isLogin]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_FEATURES')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header open={true} pageDisplayed={GetString('PAGE_TITLE_FEATURES')} />
      <Paper className={classes.paperGrid}>
        <FeaturesNameListBox />
      </Paper>
    </>
  );
}
